<template>
  <div class="json-str-group">
    <a-textarea
      :value="modelValue"
      @input="handleChangeValue"
      :state="errFormat ? 'error' : ''"
    ></a-textarea>
    <a-tag
      v-if="errFormat"
      color="red"
    >
      {{ $t('JSON格式错误') }}
    </a-tag>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, ref } from 'vue';
import { debounce } from 'lodash-es';

export default defineComponent({
  name: 'JsonStr',
  props: {
    value: {
      type: Object,
      required: false,
      default: () => null,
    },
  },
  emits: [],
  setup(props, { emit }) {
    const errFormat = ref(false);
    const errorValue = ref('');
    const modelValue = computed(() => {
      if (errFormat.value) {
        return errorValue.value;
      }
      if (props.value) {
        try {
          if (typeof props.value === 'object') {
            return JSON.stringify(props.value);
          } else {
            return props.value;
          }
        } catch (e) {}
      }
      return null;
    });
    const handleChangeValue = debounce(e => {
      try {
        if (e.target.value) {
          const new_value = JSON.parse(e.target.value);
          emit('update:value', new_value);
        } else {
          emit('update:value', null);
        }
        errFormat.value = false;
      } catch (err) {
        errorValue.value = e.target.value;
        errFormat.value = true;
      }
    }, 200);
    return {
      props,
      modelValue,
      handleChangeValue,
      errFormat,
    };
  },
  components: {},
});
</script>
<style scoped>
.json-str-group {
  display: inline-flex;
  flex-direction: column;
  width: 100%;
  align-items: flex-end;
  gap: 4px;
}
</style>
